// Dependencies
import { FC, ReactNode } from 'react';
import { Box, IconButton, Modal, Theme } from '@mui/material';

// Icons
import { CloseIcon } from '../../assets/icons';

// Resources
import { ISxProps } from '../../resource';

// Styles
import styles from './styles';

// Interfaces
interface IDialogProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  sx: ISxProps<Theme>;
  /** Extra icon buttons rendered before the close button */
  headerActions?: ReactNode;
  containerSx?: ISxProps<Theme>;
  modalSx?: ISxProps<Theme>;
}

// Export dialog
export const Dialog: FC<IDialogProps> = ({
  open,
  onClose,
  children,
  sx,
  headerActions,
  containerSx,
  modalSx,
}) => {
  const resolvedModalSx: ISxProps<Theme> = (theme) => ({
    ...styles.dialog(theme),
    ...(modalSx ? modalSx(theme) : {}),
  });

  const resolvedContainerSx: ISxProps<Theme> = (theme) => ({
    ...styles.container(theme),
    ...(containerSx ? containerSx(theme) : {}),
  });

  // Return dialog
  return (
    <Modal open={open} onClose={onClose} sx={resolvedModalSx}>
      <Box sx={resolvedContainerSx}>
        <Box sx={sx}>
          <Box sx={styles.headerActions}>
            {headerActions}
            <IconButton size="small" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          {children}
        </Box>
      </Box>
    </Modal>
  );
};
